export const TYPE_OPTIONS = [
  { label: 'common', value: 'common' },
]
